import { handleActions } from 'redux-actions';

import {
  setThreshold,
  setScaling,
  resetThresholdScaling,
} from 'store/actions/trial-balance/trial-balance-action';
import TrialBalanceThresholdScaling from 'models/api/trial-balance/trial-balance-threshold-scaling-model';

export default handleActions(
  {
    [setThreshold]: (thresholdScaling, { payload }) => {
      return thresholdScaling.setThreshold(payload);
    },
    [setScaling]: (thresholdScaling, { payload }) => {
      return thresholdScaling.setScaling(payload);
    },
    [resetThresholdScaling]: () => {
      return new TrialBalanceThresholdScaling();
    },
  },
  new TrialBalanceThresholdScaling(),
);
